import { SessionInfo } from 'shared/models/session';
import { getDevsiteFullPath } from 'shared/utils/devsite';
import routes from 'config/developerSite/routes';
import { session } from './session';

/**
 * Redirects users to proper site locations based on an HTTP status code
 */
const authenticationRedirectHandler = async (status: number) => {
  const sessionInfo = await session.getInfo();
  const route = getAuthenticationRedirectRoute(status, sessionInfo);
  if (route) window.location.assign(route);
};

export const getAuthenticationRedirectRoute = (status: number, sessionInfo: SessionInfo) => {
  if (status === 401) {
    // A 401 while already logging out must not send the user to login with path=/logout.
    // That return path logs them in and immediately logs them out again.
    if (window.location.pathname.endsWith(routes.logout)) {
      return null;
    }
    if (window.location.href.includes('welcome')) {
      return routes.login;
    }
    return routes.loginPath(window.location.pathname, sessionInfo.platform);
  }
  if (status === 403) {
    return getDevsiteFullPath(routes.forbidden);
  }

  return null;
};

export default authenticationRedirectHandler;
